module.exports = __webpack_public_path__ + "img/az.f75b772d.png";